var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTrashIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.102 3.136V.65H5.656v2.486H.288v1.342h1.606l1.144 14.894h11.726l1.144-14.894h1.826V3.136h-5.632zM6.998 1.97h3.784v1.144H6.998V1.97zM5.744 16.182l-.528-9.746 1.342-.066.528 9.746-1.342.066zm3.806-.066H8.208V6.392H9.55v9.724zm2.464.044-1.342-.066.528-9.746 1.342.066-.528 9.746z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrashIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trashIcon.95955af4.svg";
export { ForwardRef as ReactComponent };